module.exports = __webpack_public_path__ + "28919d7c72e9443586032c2f68a9bbf7.png";